import type { ProductType, TestCase } from "../types";

export const TEST_CASES: TestCase[] = [
	{
		id: "cash-out-withdraw",
		name: "Cash-out/Withdraw",
		productType: "withdraw",
		instructions: `**What to Test:**
Perform a cash-out/withdraw transaction for £1.00 to United Kingdom.

**Steps:**
1. Set CASH-OUT COUNTRY = United Kingdom
2. Set amount = 1.00 USD/USDC
3. Complete the transaction in your wallet application
4. Screenshot the transaction status showing "Pending user pickup"
5. Share the Reference Number and Date of Birth with MoneyGram team
6. MoneyGram will complete the transaction
7. Screenshot the final transaction details showing "Completed" status`,
		requiredFields: {
			referenceNumber: true,
			dateOfBirth: true,
			transactionStatus: true,
			amount: true,
			fees: true,
			amountReceived: true,
			transactionId: true,
		},
	},
	{
		id: "refund",
		name: "Refund",
		productType: "withdraw",
		instructions: `**What to Test:**
Test the refund/cancellation flow for a cash-out transaction.

**Steps:**
1. Perform a cash-out transaction for 2.00 USD/USDC
2. Share the Reference Number with MoneyGram team
3. Once completed, initiate a 'Cancel' transaction in your wallet
4. After cancellation completes, screenshot showing "Refunded" status`,
		requiredFields: {
			referenceNumber: true,
			transactionStatus: true,
		},
	},
	{
		id: "cash-in-deposit",
		name: "Cash-in/Buy/Deposit",
		productType: "deposit",
		instructions: `**What to Test:**
Perform a cash-in/deposit transaction at a MoneyGram agent location.

**Steps:**
1. Set CASH-IN COUNTRY = United Kingdom
2. Set amount = 3.00 USD/USDC
3. Find Payment Location: Enter '48 Elm Row Edinburgh EH7 4AH'
4. Select 'BM GLOBALX LIMITED' from the results
5. Complete the transaction in your application
6. Screenshot showing "Pending payment" status
7. MoneyGram will process within 24 hours
8. Screenshot final transaction showing "Completed" status`,
		requiredFields: {
			referenceNumber: true,
			transactionStatus: true,
			amount: true,
			fees: true,
			amountReceived: true,
			transactionId: true,
		},
	},
];

// Helper function to get applicable test cases based on product type
export const getApplicableTestCases = (
	productType: ProductType,
): TestCase[] => {
	if (productType === "both") {
		return TEST_CASES;
	}
	return TEST_CASES.filter((tc) => tc.productType === productType);
};
